module.exports = __webpack_public_path__ + "static/img/bianjituijian.3cfb66c9.png";